export default {"src":"/_next/static/media/gray-square-meters.bd87f3bb.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};